// Extraction Job Status Constants (matching backend enum values)
export const EXTRACTION_JOB_STATUS = {
  REQUESTED: 0, 
  PROCESSING: 1,
  COMPLETED: 2,
  NEEDS_REVIEW: 3,
  FAILED: 4,
  EXPORTING: 5,
  EXPORTED: 6,
  EXPORT_FAILED: 7,
  UNPROCESSABLE: 8,
  AUGMENTING: 9,
  AUGMENTATION_REVIEW: 10,
  READY_FOR_EXPORT: 11,
  AUGMENTATION_FAILED: 12
};

// Status Display Mappings
export const STATUS_DISPLAY = {
  [EXTRACTION_JOB_STATUS.REQUESTED]: 'Requested',
  [EXTRACTION_JOB_STATUS.PROCESSING]: 'Processing', 
  [EXTRACTION_JOB_STATUS.COMPLETED]: 'Completed',
  [EXTRACTION_JOB_STATUS.NEEDS_REVIEW]: 'Needs Review',
  [EXTRACTION_JOB_STATUS.FAILED]: 'Failed',
  [EXTRACTION_JOB_STATUS.EXPORTING]: 'Exporting',
  [EXTRACTION_JOB_STATUS.EXPORTED]: 'Exported',
  [EXTRACTION_JOB_STATUS.EXPORT_FAILED]: 'Export Failed',
  [EXTRACTION_JOB_STATUS.UNPROCESSABLE]: 'Unprocessable',
  [EXTRACTION_JOB_STATUS.AUGMENTING]: 'Augmenting',
  [EXTRACTION_JOB_STATUS.AUGMENTATION_REVIEW]: 'Augmentation Review',
  [EXTRACTION_JOB_STATUS.READY_FOR_EXPORT]: 'Ready for Export',
  [EXTRACTION_JOB_STATUS.AUGMENTATION_FAILED]: 'Augmentation Failed'
};

// Status Badge Variants
export const STATUS_VARIANTS = {
  [EXTRACTION_JOB_STATUS.REQUESTED]: 'secondary',
  [EXTRACTION_JOB_STATUS.PROCESSING]: 'info',
  [EXTRACTION_JOB_STATUS.COMPLETED]: 'success',
  [EXTRACTION_JOB_STATUS.NEEDS_REVIEW]: 'warning',
  [EXTRACTION_JOB_STATUS.FAILED]: 'danger',
  [EXTRACTION_JOB_STATUS.EXPORTING]: 'info',
  [EXTRACTION_JOB_STATUS.EXPORTED]: 'primary',
  [EXTRACTION_JOB_STATUS.EXPORT_FAILED]: 'danger',
  [EXTRACTION_JOB_STATUS.UNPROCESSABLE]: 'dark',
  [EXTRACTION_JOB_STATUS.AUGMENTING]: 'info',
  [EXTRACTION_JOB_STATUS.AUGMENTATION_REVIEW]: 'warning',
  [EXTRACTION_JOB_STATUS.READY_FOR_EXPORT]: 'success',
  [EXTRACTION_JOB_STATUS.AUGMENTATION_FAILED]: 'danger'
};